// extracted by mini-css-extract-plugin
module.exports = {"container":"_2LY-nPuslYZQGJbWGGwaiM","groupsList":"_2Av0jEfTlUuA76i-Q2LqE1"};